import { globals } from "@client/globals";
import { connectCustom } from "@client/lib/misc";
import { viewportSelector } from "@client/selectors";
import { type BaseAppState } from "@client/types";
import Component, { type ModalProps } from "./component";

const mapStateToProps = (state: BaseAppState, props: Omit<ModalProps, "viewport">): ModalProps => {
  return {
    ...props,
    appType: globals.mode,
    viewport: viewportSelector(state),
    width: props.width ?? 600
  };
};

export default connectCustom(mapStateToProps)(Component);
